var LGFG = LGFG || {};
LGFG.WF = LGFG.WF || {};

LGFG.WF.KenticoSettings = LGFG.WF.KenticoSettings || (function () {

    var _retrieving = false;

    var getSetting = function (key, callback) {
        var _key = key.toLowerCase();
        if (typeof LGFG.WF.KenticoSettings[_key] !== 'undefined') {
            callback(LGFG.WF.KenticoSettings[_key]);
        } else {
            if (!_retrieving) {
                _retrieving = true;
                $.ajax({
                    url: '/Umbraco/Api/UmbracoSettings/' + key,
                    success: function (result) {
                        LGFG.WF.KenticoSettings[_key] = result;
                        callback(LGFG.WF.KenticoSettings[_key]);
                        _retrieving = false;
                    }
                });
            } else {
                setTimeout(function() {
                    LGFG.WF.KenticoSettings.get(key, callback);
                }, 100);
            }
        }
    };

    return {
        get: getSetting
    };
})();